<div echarts [options]="chartOption" [ngStyle]="{width, height}"></div>

